import CreateTicket from "./CreateTicket";
import TicketsList from "./TicketsList";
import React from "react";
import SmetaTabs from "../../../Tools/Tabs/SmetaTabs";
import { SmetaTabItem } from "../../../Tools/Tabs/PinIcons";

export default function SupportRequest() {
  return (
    <SmetaTabs id="supportRequestForm" style={{ width: "100%", height: "100%" }}>
      <SmetaTabItem
        id="NewTicket"
        label="Новая заявка"
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <CreateTicket />
      </SmetaTabItem>
      <SmetaTabItem
        id="TicketsList"
        label="Список заявок"
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <TicketsList />
      </SmetaTabItem>
    </SmetaTabs>
  );
}
